import { render, staticRenderFns } from "./ItemSearchList.vue?vue&type=template&id=48a36cf3"
import script from "./ItemSearchList.vue?vue&type=script&lang=js"
export * from "./ItemSearchList.vue?vue&type=script&lang=js"
import style0 from "./ItemSearchList.vue?vue&type=style&index=0&id=48a36cf3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports